module.exports = __webpack_public_path__ + "static/psychic-interior-03-bf6d456404bbe835f3b75da951e51e70.jpg";